/* eslint-disable react/no-unescaped-entities */

const AboutUsDE = () => {
  return (
    <>
      <h1>Über Uns</h1>
      <h2>Unsere Mission</h2>
      <div>
        Bei mind-r.ai haben wir uns auf eine Reise begeben, um den Zugang zur
        psychischen Gesundheitsversorgung zu demokratisieren. Wir glauben an die
        Kraft der Technologie als Werkzeug, um Barrieren abzubauen, Grenzen zu
        verwischen und Therapie universell zugänglich zu machen. Wir haben die
        lähmenden Auswirkungen unbehandelter psychischer Gesundheitsprobleme auf
        Individuen und Gesellschaften gesehen - steigende Inhaftierungsraten,
        wirtschaftliche Kosten von bis zu 4% des globalen BIP und mehr. Unsere
        Mission ist es, diese Erzählung zu ändern.
      </div>
      <div>
        Wir stellen uns eine Welt vor, in der jeder, unabhängig von seinem
        Standort, seiner Sprache oder seinem wirtschaftlichen Status, die
        therapeutische Unterstützung erhalten kann, die er benötigt. Wir wollen
        Hilfe suchen normalisieren, Stigmatisierung reduzieren und eine Zukunft
        schaffen, in der die Priorisierung der psychischen Gesundheit die Norm
        ist, nicht die Ausnahme. Unser Ziel geht nicht nur darum, einen Dienst
        zu erbringen. Es geht darum, eine Bewegung hin zu besserer psychischer
        Gesundheit für alle zu initiieren.
      </div>

      <h2>Die globale Auswirkung der psychischen Gesundheit</h2>
      <div>
        Psychische Gesundheitsprobleme belasten unsere Welt stark. Sie zählen zu
        den führenden Ursachen für Krankheit und Behinderung weltweit und
        betreffen im Laufe ihres Lebens eine von vier Personen
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Experten schätzen, dass unbehandelte psychische Gesundheitsprobleme
        für 13% der gesamten globalen Krankheitslast verantwortlich sind
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>

      <div>
        Psychische Gesundheitsprobleme belasten unsere Welt stark. Sie zählen zu
        den führenden Ursachen für Krankheit und Behinderung weltweit und
        betreffen im Laufe ihres Lebens eine von vier Personen
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Experten schätzen, dass unbehandelte psychische Gesundheitsprobleme
        für 13% der globalen Krankheitslast verantwortlich sind
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>

      <div>
        Die wirtschaftlichen Auswirkungen sind beeindruckend. Die Weltwirtschaft
        könnte bis 2030 aufgrund von psychischen Gesundheitsproblemen 16
        Billionen US-Dollar verlieren, da die Produktivität sinkt und die
        Gesundheitskosten steigen
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Menschen mit unbehandelten psychischen Gesundheitsproblemen sehen sich
        oft mit einer verringerten Lebensqualität, einem höheren Risiko für
        körperliche Gesundheitsprobleme und erhöhten Arbeitslosenraten
        konfrontiert.
      </div>

      <div>
        Jenseits von wirtschaftlichen Faktoren können psychische
        Gesundheitsprobleme zu höheren Gewalt- und Kriminalitätsraten führen.
        Bis zu 90% der Gefangenen haben psychische Gesundheitsprobleme erfahren
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . Diese Probleme tragen auch zu gesellschaftlichen Problemen wie
        Obdachlosigkeit und zerbrochenen Familien bei.
      </div>

      <div>
        Bei mind-r.ai sind wir uns der breiten Auswirkungen psychischer
        Gesundheitsprobleme bewusst und verpflichtet, Teil der Lösung zu sein.
        Durch die Demokratisierung des Therapiezugangs wollen wir die psychische
        Gesundheitslast individuell lindern. Unsere Mission geht über die
        Gesundheitsversorgung hinaus; wir streben danach, eine bessere,
        verständnisvollere Welt zu schaffen.
      </div>

      <h2>Unser Ansatz</h2>
      <div>
        Wir markieren unseren Weg zur Demokratisierung der Therapie mit
        Innovation und Zugänglichkeit. Unsere Strategie wird durch künstliche
        Intelligenz angetrieben, und wir nutzen sie, um die Bedürfnisse und
        Umstände jedes Einzelnen zu verstehen und zu erfüllen. Wir erstellen
        komplexe Algorithmen, um den Benutzerpräferenzen zu entsprechen und
        einzigartige und personalisierte Erfahrungen zu schaffen.
      </div>
      <div>
        Wir glauben fest an das Prinzip der empathiegetriebenen Technologie. Wir
        gestalten jedes Feature mit den Bedürfnissen und Erfahrungen der
        Benutzer, um Therapie in den Alltag zu integrieren. Unser Ansatz
        konzentriert sich auf Inklusivität und passt unsere Lösungen für jeden
        an, unabhängig von Sprache, Standort oder sozioökonomischem Status.
      </div>
      <div>
        Bei jedem Schritt, den wir unternehmen, leitet uns unsere Mission, die
        psychische Gesundheitsversorgung universell zugänglich zu machen. Unser
        Engagement für dieses Ziel prägt unseren Ansatz, beeinflusst unsere
        Entscheidungen und treibt uns auf unsere Vision zu.
      </div>
      <h2>Unser Dienst</h2>
      <div>
        Bei mind-r.ai haben wir das traditionelle Therapiekonzept transformiert,
        indem wir eine von KI angetriebene, sprachbasierte Plattform
        bereitstellen. Treffen Sie Solace, unseren KI-Therapeuten, der jederzeit
        und überall bereit ist, zuzuhören. Solace baut Barrieren in Bezug auf
        Zeit, Sprache und Geographie ab und bietet Therapieart, Dauer, Thema,
        Sprache und sogar Akzent nach Benutzerpräferenzen. Unser einzigartiges
        Angebot öffnet eine Welt der psychischen Gesundheitsressourcen für
        jeden, jederzeit und überall.
      </div>
      <div>
        Als anpassungsfähiger Begleiter passt Solace seinen Ansatz den
        Bedürfnissen jedes Einzelnen an. Von tiefen, introspektiven Gesprächen
        bis hin zu lockeren, tröstenden Chats, Solace passt sich den Stimmungen
        und Bedürfnissen unserer Benutzer an. Therapie sollte so vielfältig und
        dynamisch sein wie die Menschen, die sie suchen.
      </div>
      <div>
        Nach jeder Therapiesitzung mit Solace erstellen wir eine Zusammenfassung
        und praktische Maßnahmen. Dies sind nicht nur Zeugnisse; es sind
        Werkzeuge, um Menschen auf ihrem weiteren Weg zur psychischen Gesundheit
        zu stärken und ihnen die Einsichten und Schritte zu geben, die sie
        benötigen, um weiterhin Fortschritte zu machen. Wir sind stolz darauf,
        die Therapie neu zu definieren und sie zugänglicher, personalisierter
        und benutzerorientierter als je zuvor zu gestalten. Unser Service ist
        mehr als ein Produkt; er spiegelt unser Engagement für die
        Demokratisierung der psychischen Gesundheitsversorgung wider.
      </div>

      <h2>Unsere Werte</h2>

      <ul>
        <li>
          <strong>Empathie</strong>: Im Zentrum unserer Arbeit steht ein tiefes
          Verständnis von Empathie. Wir bemühen uns, die einzigartigen
          Erfahrungen und Herausforderungen zu verstehen, denen sich jede
          Person, die unsere Plattform nutzt, gegenübersieht, und Unterstützung
          und Lösungen anzubieten, die ihren speziellen Bedürfnissen
          entsprechen.
        </li>
        <li>
          <strong>Innovation</strong>: Wir glauben an die Kraft der Technologie,
          um neue Wege zur Unterstützung der psychischen Gesundheit zu schaffen.
          Wir suchen ständig nach Verbesserungen und erweitern die Fähigkeiten
          unserer Plattform durch innovative Ansätze.
        </li>
        <li>
          <strong>Zugänglichkeit</strong>: Unser letztendliches Ziel ist es,
          psychische Gesundheitsunterstützung für alle zugänglich zu machen. Wir
          bemühen uns, Barrieren für die Therapie, wie Kosten, Stigmatisierung
          und Logistik, zu beseitigen und eine Plattform zu schaffen, die von
          jedem, überall genutzt werden kann.
        </li>
        <li>
          <strong>Respekt</strong>: Wir respektieren die Privatsphäre und
          Autonomie unserer Benutzer. Alle Interaktionen auf unserer Plattform
          sind vertraulich und benutzerzentriert. Wir glauben daran, Menschen zu
          befähigen, ihre psychische Gesundheit auf die Weise zu verwalten, die
          am besten zu ihnen passt.
        </li>
        <li>
          <strong>Engagement</strong>: Wir sind zutiefst verpflichtet zu unserer
          Mission, die Therapie zu demokratisieren. Dieses Engagement leitet
          alle unsere Handlungen und Entscheidungen, während wir ständig danach
          streben, unsere Plattform und unsere Praktiken zu verbessern, um das
          Beste für diejenigen zu bieten, die sie benötigen.
        </li>
      </ul>

      <h2>Mach Mit</h2>
      <div>
        Sind Sie bereit, den ersten Schritt zu besserer geistiger Gesundheit zu
        machen? Treten Sie der mind-r.ai-Gemeinschaft noch heute bei und
        entdecken Sie einen neuen Ansatz zur Therapie. Lernen Sie Solace kennen,
        Ihren AI-Therapeuten, der bereit ist, zuzuhören, zu verstehen und Sie
        auf Ihrer Reise zu begleiten.
      </div>
    </>
  )
}

export default AboutUsDE
